<div class="panelAddRoles">
  <div class="custom-container">
    <form [formGroup]="formGroup" #myFormUserEdit>
      <mat-card>
        <div class="main-header">
          <mat-icon color="primary" class="back-arrow" [routerLink]="'/settingsAdmin'">arrow_back_ios</mat-icon>
          <mat-card-title class="card-title">Agregar Rol</mat-card-title>
        </div>
        <mat-card-content>
          <mat-card class="paper-card">
            <mat-card-header>
              <mat-card-subtitle>Datos Generales</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="input-row">
                <div class="col-12 custom-input-container">
                  <mat-form-field>
                    <mat-label>Nombre</mat-label>
                    <input formControlName="rolName" matInput placeholder="Nombre" required />
                  </mat-form-field>
                  <span>{{ getError("rolName") }}</span>
                </div>
              </div>
              <div class="input-row">
                <div class="col-6 custom-input-container">
                  <mat-form-field>
                    <mat-label>Nombre a Mostrar</mat-label>
                    <input formControlName="rolShortName" matInput placeholder="Nombre a mostrar" required />
                  </mat-form-field>
                  <span>{{ getError("rolShortName") }}</span>
                </div>
                <div class="col-6 custom-input-container">
                  <mat-form-field>
                    <mat-label>Cliente </mat-label>
                    <mat-select formControlName="client" placeholder="Cliente">
                      <mat-option value=""> General </mat-option>
                      <mat-option *ngFor="let client of clientes" [value]="client.id">{{ client.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span>{{ getError("client") }}</span>
                </div>
              </div>
              <div class="input-row">
                <div class="col-6 custom-input-container">
                  <mat-form-field>
                    <mat-label>Descripción del rol</mat-label>
                    <input formControlName="rolDescription" matInput placeholder="Descripción" />
                  </mat-form-field>
                </div>
                <div class="col-6 custom-input-container slider-container">
                  <mat-slide-toggle 
                    formControlName="vinDirectAssign" 
                    [disabled]="!hasVinDirectAssignPermission">
                    Asignación Directa de VIN
                  </mat-slide-toggle>

                </div>
              </div>
              <div class="input-row">
                <div class="col-12 custom-input-container">
                  <h3>Permisos</h3>
                  <mat-accordion multi hideToggle class="permission-expand">
                    <mat-expansion-panel *ngFor="let view of viewList"  >
          
                      <mat-expansion-panel-header >
                        <mat-panel-title>
                          <div class="view-icon">
                            <img class="img-view" [src]="view.icon | findUrl" alt="Icono de la vista" />
                          </div>
                          <div class="font-weight-bold card-expansion-title">
                            {{view.name}}
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <div class="panel-title">
                        <mat-slide-toggle [ngModel]="view.isActive" [ngModelOptions]="{standalone: true}" (change)="selectView(view)"></mat-slide-toggle> Ver Módulo
                      </div>
                      <div class="selected-list-container">
                        <mat-list class="selected-list">
                          <mat-list-item *ngFor="let permit of view.availablePermissions" class="custom-card minimalist-font">
                          <div class="checkbox-spacing">
                            <mat-slide-toggle [(ngModel)]="permit.isActive" [ngModelOptions]="{standalone: true}"></mat-slide-toggle>
                            <div class="selected-item-text">
                              {{ permit.name.split('-')[0].trim() }}
                            </div>
                          </div>
                          </mat-list-item>
                        </mat-list>
                      </div>
          
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

        </mat-card-content>
        <mat-card-actions>
          <button class="form-control btn-primary btn-agregar" [ngClass]="{'disabled': formGroup.invalid}" (click)="onSubmit(formGroup.value)" [disabled]="formGroup.invalid" mat-button>
            Agregar
          </button>
        </mat-card-actions>
      </mat-card>
    </form>
  </div>
</div>